<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    {{ 'report.apartmentRound.addUser' | translate }}
  </div>
  <form class="ion-padding-bottom"
    [formGroup]="formGroup"
    (ngSubmit)="save()">
    <h4>{{ 'item.name' | translate }}</h4>
    <ion-item lines="none">
      <ion-input autocapitalize="on"
        formControlName="name"></ion-input>
    </ion-item>
    <h4>{{ 'item.role' | translate }}</h4>
    <ion-item lines="none">
      <ion-input autocapitalize="on"
        formControlName="role"></ion-input>
    </ion-item>
    <h4>{{ 'item.email' | translate }}</h4>
    <ion-item lines="none">
      <ion-input autocapitalize="on"
        formControlName="email"></ion-input>
    </ion-item>
    <h4>{{ 'item.company' | translate }}</h4>
    <ion-item lines="none">
      <ion-input autocapitalize="on"
        formControlName="company"></ion-input>
    </ion-item>
    <div class="ion-margin-top">
      <ion-button color="light"
        type="submit"
        [disabled]="!formGroup.valid">{{ 'general.save' | translate }}</ion-button>
    </div>
  </form>
</app-main-dialog>